import { Component, Input, Output, ElementRef, OnInit, OnChanges, AfterViewInit, EventEmitter, style, trigger, state, transition, animate } from '@angular/core';
import { WindowService } from "../services/window.service";
import { ProductGroup } from "../model/product.group";
import { MainConfigurationInterface } from "../services/configuration.loader";
import { Product } from "../model/product";

import { Logger } from "../utils/logger";

@Component({
    selector: 'total_price_panel',
    templateUrl: "./total_price.panel.component.html",
    // animations: [
    //     trigger('visibleState', [
    //         state('inactive', style({
    //             opacity: '0'
    //         })),
    //         state('active',   style({
    //             opacity: '1'
    //         })),
    //         transition('inactive => active', animate('200ms ease-in')),
    //         transition('active => inactive', animate('200ms ease-out'))
    //     ])
    // ]
})
export class TotalpricePanel implements OnInit, AfterViewInit, OnChanges {

    @Output('onHide')
    public displayEvent: EventEmitter<boolean>;

    @Output('onEmailBox')
    public emailBoxEvent: EventEmitter<boolean>;


    @Output('onLinkBox')
    public linkBoxEvent: EventEmitter<boolean>;

    @Input("show")
    // public needShow = true;
    public isShown = false;

    @Input("products")
    public selectedProducts: Array<ProductGroup> = [];

    @Input("subProducts")
    public selectedSubProducts: Array<ProductGroup> = [];

    @Input()
    public configuration: MainConfigurationInterface;

    constructor(public el: ElementRef, public windowService: WindowService, public logger: Logger) {
        this.displayEvent = new EventEmitter<boolean>();
        this.emailBoxEvent = new EventEmitter<boolean>();
        this.linkBoxEvent = new EventEmitter<boolean>();
    }

    ngAfterViewInit(): any {
        this.fitSidebar();
        this.windowService.addResizeEventListener(() => {
            this.fitSidebar();
        });
    }


    ngOnInit(): any {

    }


    ngOnChanges(changes: any): any {
        // if (typeof changes.needShow !== 'undefined') {
        //     if (changes.needShow.currentValue && changes.needShow.currentValue !== changes.needShow.previousValue) {
        //         this.show();
        //     } else {
        //         this.hide();
        //     }
        // }
        // this.logger.info(this.selectedSubProducts);

    }

    getTotal() {
        let res = 0.00;
        this.selectedProducts.forEach((group: ProductGroup) => {
            let product: Product = group.getProducts()[0];
            if (product) {
                res += Number(product.price.getValue());
            }
        });

        let major = Math.floor(res / 1000);
        let minor = Math.round(res % 1000).toString();
        if (minor.length < 3) {
            minor = "0" + minor;
        }
        let result = "0";
        if (major > 0) {
            result = major + "." + minor;
        } else {
            result = minor;
        }

        return result;
    }


    fitSidebar() {
        let container = this.el.nativeElement.querySelector('.price-details-container');
        if (container) {
            let screenWidth = this.windowService.getScreenWidth();
            let mainContainerWidth = this.windowService.getMainContainerWidth();
            let aspectRatio = this.windowService.getAspectRatio();
            let realAspectRatio = this.windowService.getRealAspectRatio();

            container.style.marginRight = -1 * (this.windowService.convertSize((mainContainerWidth / 2) - 20)) + 'px';
        }

    }

    hide() {
        this.displayEvent.emit(true);
        // try {
        //     let s = this.el.nativeElement;
        //     this.animator.setType("fadeOut").hide(s).then(()=> {
        //         this.isShown = false;
        //         this.displayEvent.emit(true);
        //     });
        // }catch (e) {
        //     this.logger.error(e);
        // }
    }

    show() {
        // try {
        //     this.isShown = true;
        //     let s = this.el.nativeElement;
        //     this.animator.setType("fadeIn").show(s).then(()=> {
        //
        //     });
        // }catch (e) {
        //     this.logger.error(e);
        // }
    }


    savePageState() {
        this.linkBoxEvent.emit(true);
    }

    sendEmail() {
        this.emailBoxEvent.emit(true);
    }
}



// WEBPACK FOOTER //
// ./src/app/price_total/total_price.panel.component.ts